<template>
  <div class="content_page" :class="[$store.state.isMirroring && 'mirror_box']">
    <Tabbar :title="$t('withdrawAccount.bindThirdPartyTitle', [channel])"></Tabbar>
    <Tip :content="withdrawType === 14 ? $t('withdrawAccount.bindNote2') : $t('withdrawAccount.bindNote')"></Tip>
    <div class="content_area">
      <div
        v-if="this.withdrawType !== 15 && this.withdrawType !== 20"
        class="content_item content_item_space"
        :class="[$store.state.isMirroring && 'mirror']"
      >
        <div class="content_item_title" :class="[$store.state.isMirroring && 'mirror']">
          {{ $t('common.firstName') }}
        </div>
        <input class="content_item_input" type="text" disabled :value="this.$store.state.userInfo.firstName" />
      </div>
      <div
        v-if="this.withdrawType !== 15 && this.withdrawType !== 20 && this.$store.state.userInfo.middleName"
        class="content_item content_item_space"
        :class="[$store.state.isMirroring && 'mirror']"
      >
        <div class="content_item_title" :class="[$store.state.isMirroring && 'mirror']">
          {{ $t('common.middleName') }}
        </div>
        <input
          class="content_item_input"
          :class="[$store.state.isMirroring && 'mirror']"
          type="text"
          disabled
          :value="this.$store.state.userInfo.middleName"
        />
      </div>
      <div
        v-if="this.withdrawType !== 15 && this.withdrawType !== 20 && this.$store.state.userInfo.lastName"
        class="content_item content_item_space"
        :class="[$store.state.isMirroring && 'mirror']"
      >
        <div class="content_item_title" :class="[$store.state.isMirroring && 'mirror']">
          {{ $t('common.lastName') }}
        </div>
        <input class="content_item_input" type="text" disabled :value="this.$store.state.userInfo.lastName" />
      </div>
      <div
        v-if="this.withdrawType === 14"
        class="content_item content_item_space"
        :class="[$store.state.isMirroring && 'mirror']"
      >
        <div class="content_item_title_usdt" :class="[$store.state.isMirroring && 'mirror']">
          {{ $t('withdrawAccount.usdtAddress') }}
        </div>
      </div>
      <div v-else class="content_item content_item_space" :class="[$store.state.isMirroring && 'mirror']">
        <div class="content_item_title" :class="[$store.state.isMirroring && 'mirror']">
          {{ $t('account.account') }}
        </div>
        <input
          class="content_item_input"
          type="text"
          :placeholder="$t('withdrawAccount.accountPlaceholder')"
          v-model="account"
        />
      </div>
      <div
        v-if="withdrawType === 18 || withdrawType === 19"
        class="content_item content_item_space"
        :class="[$store.state.isMirroring && 'mirror']"
      >
        <div class="content_item_title" :class="[$store.state.isMirroring && 'mirror']">
          {{ $t('bankData.documentId') }}
        </div>
        <input
          class="content_item_input"
          inputmode="numeric"
          type="tel"
          :placeholder="$t('bankData.documentIdPlaceholder')"
          v-model="documentId"
        />
      </div>
      <div v-if="withdrawType === 14" class="content_item_usdt">
        <input type="text" :maxlength="34" :placeholder="$t('withdrawAccount.trc20Placeholder')" v-model="account" />
      </div>
      <div v-if="withdrawType === 14" class="content_item_tip" :class="[$store.state.isMirroring && 'mirror']">
        <p>{{ $t('withdrawAccount.minimumLimit') }}</p>
        <p>{{ $t('withdrawAccount.usdtFee') }}</p>
      </div>
      <div
        v-if="needPayoutAddress"
        class="content_item content_item_space"
        :class="[$store.state.isMirroring && 'mirror']"
      >
        <div class="content_item_title" :class="[$store.state.isMirroring && 'mirror']">
          {{ $t('bankData.city') }}
        </div>
        <input class="content_item_input" v-model="city" />
      </div>
      <div
        v-if="needPayoutAddress"
        class="content_item content_item_space"
        :class="[$store.state.isMirroring && 'mirror']"
      >
        <div class="content_item_title" :class="[$store.state.isMirroring && 'mirror']">
          {{ $t('bankData.postalCode') }}
        </div>
        <input class="content_item_input" v-model="postalCode" @input="validatePostalCode" />
      </div>
      <div
        v-if="needPayoutAddress"
        class="content_item content_item_space"
        :class="[$store.state.isMirroring && 'mirror']"
      >
        <div class="content_item_title" :class="[$store.state.isMirroring && 'mirror']">
          {{ 'addressLine' }}
        </div>
        <input class="content_item_input" v-model="addressLine" />
      </div>
      <CommonBtn
        v-if="withdrawType === 14"
        class="next_btn"
        :disabled="!isShow"
        :text="$t('common.done')"
        :on-click="EditThirdPartyPay"
      />
      <CommonBtn v-else class="next_btn" :text="$t('common.done')" :on-click="EditThirdPartyPay" />
      <CommonBtn class="next_btn delete" :text="$t('common.delete')" :on-click="unbind" />
    </div>
    <CheckPayPassword :show="showKeyboard" v-bind:on-success="onPasswordSuccess" v-bind:on-close="onClose" />
  </div>
</template>

<script>
import Tabbar from '@/components/Tabbar.vue'
import { Toast } from 'vant'
import CommonInput from '@/components/CommonInput'
import CommonBtn from '@/components/CommonBtn'
import CheckPayPassword from '@/components/CheckPayPassword'
import linkMixins from '@/mixins/linkMixins'
import Tip from '@/components/LinkAccount/Tip.vue'

export default {
  name: 'EditThirdPartyPayAccount',
  mixins: [linkMixins],
  data() {
    return {
      channel: '',
      account: '',
      documentId: '',
      city: '',
      postalCode: '',
      addressLine: '',
      withdrawType: undefined,
      isShow: false,
      paramsAccount: undefined,
      paramsDocumentId: undefined,
      paramsWithdrawType: undefined,
      paramsState: undefined,
      paramsCity: undefined,
      paramsPostalCode: undefined,
      paramsAddressLine: undefined,
      withdrawId: undefined,
      binding: false
    }
  },
  components: {
    Tabbar,
    Tip,
    CommonBtn,
    CheckPayPassword,
    CommonInput
  },
  mounted() {
    switch (this.$route.name) {
      case 'EditGcashAccount':
        this.channel = 'GCash'
        this.withdrawType = 4
        break
      case 'EditGoPayAccount':
        this.channel = 'GoPay'
        this.withdrawType = 7
        break
      case 'EditOVOAccount':
        this.channel = 'OVO'
        this.withdrawType = 8
        break
      case 'EditDANAAccount':
        this.channel = 'DANA'
        this.withdrawType = 9
        break
      case 'EditPayPalAccount':
        this.channel = 'PayPal'
        this.withdrawType = 10
        break
      case 'EditEPayAccount':
        this.channel = 'Epay'
        this.withdrawType = 11
        break
      case 'EditUSDTAccount':
        this.channel = 'USDT (TRC-20)'
        this.withdrawType = 14
        break
      case 'EditQiwiAccount':
        this.channel = 'Qiwi'
        this.withdrawType = 13
        break
      case 'EditNewPayPal':
        this.channel = 'PayPal'
        this.withdrawType = 15
        break
      case 'EditUPIAccount':
        this.channel = 'UPI'
        this.withdrawType = 17
        break
      case 'EditJazzCash':
        this.channel = 'Jazz Cash'
        this.withdrawType = 18
        break
      case 'EditEasyPaisa':
        this.channel = 'Easypaisa'
        this.withdrawType = 19
        break
      case 'EditPayoutPayPalAccount':
        this.channel = 'PayPal'
        this.withdrawType = 20
        break
      default:
        break
    }
  },
  computed: {
    // 美国 countryNo=213 不需要地址字段，其它地区仍需要
    needPayoutAddress() {
      return this.withdrawType === 20 && Number(this.$store.state.userInfo.countryNo) !== 213
    }
  },
  created() {
    this.paramsAccount = this.$route.params.account
    this.paramsDocumentId = this.$route.params.documentId
    this.paramsCity = this.$route.params.city
    this.paramsPostalCode = this.$route.params.postalCode
    this.paramsAddressLine = this.$route.params.addressLine
    this.paramsWithdrawType = this.$route.params.withdrawType
    this.paramsWithdrawId = this.$route.params.withdrawId
    this.account = this.paramsAccount
    this.documentId = this.paramsDocumentId
    this.city = this.paramsCity
    this.postalCode = this.paramsPostalCode
    this.addressLine = this.paramsAddressLine
    this.withdrawType = this.paramsWithdrawType
  },
  watch: {
    account: function (value) {
      if (this.withdrawType === 14 && value && value.length === 34) {
        this.isShow = true
      } else {
        this.isShow = false
      }
    }
  },
  methods: {
    validatePostalCode(event) {
      // 禁止输入符号空格
      const inputValue = event.target.value
      const regex = /^[0-9]+$/
      this.$nextTick(() => {
        if (!regex.test(inputValue)) {
          this.postalCode = inputValue.replace(/[^0-9]/g, '')
        }
      })
    },
    search(event) {
      if (event.target._value.length === 34) {
        this.isShow = true
      } else {
        this.isShow = false
      }
    },
    isValidEmail(email) {
      // 邮箱地址的正则表达式模式
      const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/

      // 使用正则表达式模式进行匹配
      return emailPattern.test(email)
    },
    isValidDocumentId(documentId) {
      const documentIdPattern = /^[0-9]+$/
      return documentIdPattern.test(documentId)
    },
    EditThirdPartyPay() {
      if (!this.account) {
        Toast(this.$t('withdrawAccount.accountEmptyToast'))
        return
      }
      // Gcash
      if (this.withdrawType === 4 && !this.account.match(/^09\d{9}$/)) {
        Toast(this.$t('withdrawAccount.accountFormatToast'))
        return
      }
      // Epay
      if (this.withdrawType === 11 && !this.isValidEmail(this.account)) {
        Toast(this.$t('withdrawAccount.accountFormatToast'))
        return
      }
      // Jazz Cash 和 Easy Paisa
      if ((this.withdrawType === 18 || this.withdrawType === 19) && !this.isValidDocumentId(this.documentId)) {
        Toast(this.$t('withdrawAccount.documentIdToast'))
        return
      }
      const data = {
        account: this.account,
        withdrawType: this.withdrawType,
        withdrawId: this.paramsWithdrawId,
        userId: this.$store.state.userInfo.userId,
        countryNo: this.$store.state.userInfo.countryNo,
        oldAccount: this.paramsAccount
      }
      if (this.withdrawType === 18 || this.withdrawType === 19) {
        data.documentId = this.documentId
      }
      // 非美国地区 payout paypal 补充地址字段
      if (this.needPayoutAddress) {
        data.city = this.city
        data.postalCode = this.postalCode
        data.addressLine = this.addressLine
      }
      // account 和 documentId 都没有修改时进行提示
      if (
        this.$route.params.account === this.account &&
        (!this.$route.params.documentId || this.$route.params.documentId === this.documentId) &&
        (!this.needPayoutAddress ||
          ((!this.$route.params.city || this.$route.params.city === this.city) &&
            (!this.$route.params.postalCode || this.$route.params.postalCode === this.postalCode) &&
            (!this.$route.params.addressLine || this.$route.params.addressLine === this.addressLine)))
      ) {
        Toast(this.$t('withdrawAccount.accountRepeatToast'))
      } else {
        if (this.binding) return
        this.binding = true
        this.$http
          .post(window.serverPath + '/api/account/EditThirdPartyPay', data)
          .then((res) => {
            if (res.data.code === '200') {
              this.$router.replace({
                name: 'bankcardResult',
                params: { eventId: 1 }
              })
            } else if (res.data.code === '40102') {
              Toast({ message: res.data.message })
            } else {
              Toast({ message: this.$t('withdrawAccount.editFailedToast') })
            }
          })
          .catch((err) => console.log(err))
          .finally(() => (this.binding = false))
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.content_page {
  width: 100%;
  background-color: #fff;
  position: relative;
  height: 100%;
  overflow-y: auto;
  scrollbar-width: 0;
  padding: 0 0.16rem;
}

.content_page::-webkit-scrollbar {
  width: 0;
  height: 0;
}

.content_area {
  width: 100%;
  box-sizing: border-box;
}

.content_item {
  width: 100%;
  height: 0.6rem;
  border-bottom: 1px solid #eeeef7;
  display: flex;
  flex-direction: row;
  justify-content: left;
  align-items: center;

  &.mirror {
    justify-content: right;
  }
}

.content_item_usdt {
  width: 100%;
  height: 0.6rem;
  border-bottom: 1px solid #eeeef7;
  display: flex;
  flex-direction: row;
  justify-content: left;
  align-items: center;
}

.content_item_space {
  justify-content: space-between;
}

input {
  background: none;
  outline: none;
  border: none;
  margin: 0;
  height: 0.4rem;
  width: calc(100% - 1.2rem);
  font-size: 0.14rem;
}

textarea {
  background: none;
  outline: none;
  border: none;
  margin: 0;
  height: 0.8rem;
  width: calc(100% - 1.2rem);
  font-size: 0.16rem;
  resize: none;
}

input:focus,
textarea:focus {
  border: none;
}

input:disabled {
  color: #828282;
}

input::-webkit-input-placeholder,
textarea::-webkit-input-placeholder {
  color: #aeaeae;
  font-size: 0.14rem;
}
.content_item_usdt input {
  width: 100%;
}

.content_item_title {
  font-size: 0.14rem;
  color: #2f2f2f;
  width: 1.2rem;
  text-align: left;
  font-weight: bold;

  &.mirror {
    text-align: right;
  }
}

.content_item_title_usdt {
  font-size: 0.16rem;
  color: #282828;
  width: 2.2rem;
  text-align: left;
  font-weight: bold;

  &.mirror {
    text-align: right;
  }
}

.content_item_title.required::before {
  content: '*';
  color: red;
  margin-inline-end: 0.03rem;
  position: relative;
  top: 0.02rem;
}

.content_item_input {
  text-align: right;
}

.mirror_box .content_item_input {
  text-align: left;
}

.select_account {
  flex: auto;
  color: #252525;
  font-size: 0.16rem;
  text-align: left;
}

.select_account_arrow {
  flex: none;
  box-sizing: border-box;
  padding: 5px;
}

.select_account_arrow_img {
  width: 0.12rem;
  height: 0.12rem;
}

.content_code_input {
  color: #252525;
  font-size: 0.16rem;
  width: 100%;
}

.send_code_btn {
  color: #378e5b;
  font-size: 0.14rem;
}

.done_btn_area {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 0.86rem;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  border-top: 1px solid #efefef;
  padding: 0.18rem;
  background: #ffffff;
}

.disable_btn {
  background-color: #dedef0;
}

.content_item_tip {
  margin-top: 0.12rem;
  position: relative;
  height: 0.48rem;
  font-size: 0.1rem;
  color: #ff840b;
  padding: 0.06rem 0.14rem;
  text-align: left;
  border-radius: 0.08rem;
  border: 0.005rem solid rgba(255, 132, 11, 0.4);
  background: rgba(255, 199, 20, 0.1);
  line-height: 0.18rem;
  z-index: 2;
  display: flex;
  align-items: center;
  flex-direction: column;
}

.content_item_tip.mirror {
  text-align: right;
}

.next_btn {
  margin-top: 0.16rem;
  width: 100% !important;
  font-size: 0.16rem !important;
}

.next_btn.delete {
  background: #fff;
  color: #3fbb70;
  border: 0.01rem solid #3fbb70;
}
</style>



// WEBPACK FOOTER //
// src/views/EditThirdPartyPayAccount.vue